import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen  py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mt-20 mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Please read these terms carefully before using our services
          </p>
          <div className="mt-4 px-4 py-1  bg-orange-50 rounded-lg inline-block">
            <p className="text-orange-800 text-sm font-medium">
              Last updated: <span className='text-gray-600 text-md font-bold'>December 06, 2025</span>
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="">
          <div className="prose prose-lg max-w-none">
            {/* Agreement */}
            <section className="mb-12">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6">
                <p className="text-gray-700 font-medium">
                  By accessing and using CC Technology's services, you agree to be bound by these 
                  Terms of Service and all applicable laws and regulations.
                </p>
              </div>
            </section>

            {/* Services */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Services Description
              </h2>
              <p className="text-gray-700 mb-4">
                CC Technology provides comprehensive technology solutions including but not limited to:
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                  <h3 className="font-semibold text-gray-900 mb-3">IT Services</h3>
                  <ul className="text-gray-700 space-y-2 text-sm">
                    <li>• Software Development</li>
                    <li>• System Integration</li>
                    <li>• IT Consulting</li>
                    <li>• Technical Support</li>
                  </ul>
                </div>
                
                <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                  <h3 className="font-semibold text-gray-900 mb-3">Digital Solutions</h3>
                  <ul className="text-gray-700 space-y-2 text-sm">
                    <li>• Web Development</li>
                    <li>• Mobile Applications</li>
                    <li>• Cloud Services</li>
                    <li>• Digital Transformation</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* User Responsibilities */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                User Responsibilities
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-red-100 p-2 rounded-lg mr-4">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Prohibited Activities</h3>
                    <ul className="text-gray-700 space-y-1 text-sm">
                      <li>• Violating any applicable laws or regulations</li>
                      <li>• Infringing intellectual property rights</li>
                      <li>• Distributing malware or harmful code</li>
                      <li>• Attempting unauthorized access</li>
                    </ul>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-green-100 p-2 rounded-lg mr-4">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Required Conduct</h3>
                    <ul className="text-gray-700 space-y-1 text-sm">
                      <li>• Provide accurate information</li>
                      <li>• Maintain account security</li>
                      <li>• Comply with service guidelines</li>
                      <li>• Respect other users' rights</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Payments & Billing */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Payments & Billing
              </h2>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Payment Terms</h4>
                    <ul className="text-gray-700 space-y-2 text-sm">
                      <li>• All fees are quoted in NPR</li>
                      <li>• Payment due upon invoice receipt</li>
                      <li>• Late payments incur interest</li>
                      <li>• Taxes additional where applicable</li>
                    </ul>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Refund Policy</h4>
                    <ul className="text-gray-700 space-y-2 text-sm">
                      <li>• Service-specific refund terms apply</li>
                      <li>• No refunds for delivered services</li>
                      <li>• Project cancellations may incur fees</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Intellectual Property */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Intellectual Property
              </h2>
              
              <div className="border border-yellow-200 bg-yellow-50 p-6 rounded-lg mb-6">
                <p className="text-gray-700 font-medium">
                  All content, trademarks, and data on this website are the property of CC Technology 
                  or its content suppliers and are protected by intellectual property laws.
                </p>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">Our Rights</h4>
                  <ul className="text-gray-700 space-y-2 text-sm">
                    <li>• Website content and design</li>
                    <li>• Software and applications</li>
                    <li>• Brand names and logos</li>
                    <li>• Documentation and materials</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">Your Rights</h4>
                  <ul className="text-gray-700 space-y-2 text-sm">
                    <li>• Your personal data</li>
                    <li>• Your business content</li>
                    <li>• Your intellectual property</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Limitation of Liability */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Limitation of Liability
              </h2>
              
              <div className="bg-red-50 border-l-4 border-red-400 p-6">
                <p className="text-gray-700 mb-4">
                  To the maximum extent permitted by law, CC Technology shall not be liable for any 
                  indirect, incidental, special, consequential, or punitive damages resulting from 
                  your use or inability to use our services.
                </p>
                <p className="text-gray-700 text-sm">
                  Our total liability for any claim shall not exceed the amount paid by you for 
                  the services in the six months preceding the claim.
                </p>
              </div>
            </section>

            {/* Termination */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Termination
              </h2>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 border border-gray-200 rounded-lg">
                  <span className="font-medium text-gray-900">By CC Technology</span>
                  <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
                    Immediate
                  </span>
                </div>
                
                <div className="flex justify-between items-center p-4 border border-gray-200 rounded-lg">
                  <span className="font-medium text-gray-900">By User</span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    Written Notice
                  </span>
                </div>
              </div>
            </section>

            {/* Governing Law */}
            <section className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-3 h-3 bg-blue-500 rounded-full mr-3"></div>
                Governing Law
              </h2>
              
              <div className="bg-gray-100 p-6 rounded-lg text-center">
                <p className="text-gray-700 font-medium">
                  These Terms shall be governed by and construed in accordance with the laws of Nepal, 
                  without regard to its conflict of law provisions.
                </p>
              </div>
            </section>

            {/* Contact Information */}
            <section className="bg-blue-50 p-6 rounded-lg">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Contact Information</h2>
              <p className="text-gray-700 mb-4">
                For any questions about these Terms of Service, please contact us:
              </p>
              <div className="space-y-2 text-gray-700">
                <p>Email: contact@cctechnology.com.np</p>
                <p>Phone: +977-9819931223</p>
                <p>Address: Janakpur, Nepal</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;